import React, { useContext } from "react";
import { REPORTED_SUBTABS_ID, REPORTED_TABS, USERTYPES } from "../../../../constants/Constants";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { Pivot, PivotItem } from '@fluentui/react';
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import PlatformHelper from "../../../../helpers/PlatformHelper";

const ReportedNavTabs = () => {

    const {
        roles,
        selectedValue,
        handleReportedTabChange,
        reportedAllTabs
      } = useContext(studylistContext);

    const { getThemeColor } = useContext(themeContext);

    const loadSelectedReportedTab = (item) => {
        if(item.props.itemKey === 'reported'){
         handleReportedTabChange(item.props.itemKey, REPORTED_TABS.reported, "study_3")
       }else if(item.props.itemKey === 'positive'){
         handleReportedTabChange(item.props.itemKey, REPORTED_TABS.positive, "study_22")
       }else if(item.props.itemKey === 'negative'){
         handleReportedTabChange(item.props.itemKey, REPORTED_TABS.negative, "study_23")
       }else if(item.props.itemKey === 'resubmission'){
         handleReportedTabChange("reported", "Reported", "study_25")
       }
     }

    return (
      <>
        {(REPORTED_SUBTABS_ID.includes(selectedValue) && (PlatformHelper.isFahes() || [USERTYPES.FIRMADMIN, USERTYPES.SUPERVISOR, USERTYPES.FIRMDOCTOR, USERTYPES.FIRMTECHNICIAN, USERTYPES.RADIOLOGIST].includes(roles[0]))) && (
          <>
            <div style={{  background: "var(--studylist-search-and-tab-section-background)"}}>
               <div style={{position : "relative", 
                borderLeft: getThemeColor("border"), 
                borderTop: getThemeColor("border"),
                borderRight: getThemeColor("border"),
                background: "var(--background-theme-color)",
                display: "flex",          // make it flex
                alignItems: "center",     // vertical alignment
                justifyContent: "space-between",
               }} className="xray-tabs-pivot-top">
                <div className="study-list-hide-cxr-border-top"></div>
                <Pivot  className="xray-tabs-pivot"
                aria-label="Reported tabs"
                linkSize="small"
                linkFormat={'tabs'}
                onLinkClick={(item) => loadSelectedReportedTab(item)}
                >       
                  <PivotItem headerText={t("study-list.tabs.all-studies")} itemKey="reported"></PivotItem>
                  {PlatformHelper.isFahes() && <PivotItem headerText="Positive" itemKey="positive"></PivotItem>}
                  {PlatformHelper.isFahes() && <PivotItem headerText="Negative" itemKey="negative"></PivotItem>}
                  <PivotItem headerText="Resubmitted" itemKey="resubmission"></PivotItem>
                </Pivot>
              </div>
            </div>
          </>
        )}
      </>
    )
}

export default ReportedNavTabs;

